import src from "IMAGE";
export default { src, width: 800, height: 127, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/ADQpMEVaREdUVD9CTlFRUUVCQkI5Ozs7NDg4ODE0NDQtiSwH7Skr9owAAAAASUVORK5CYII="};
